import React from "react";
import acceptSVG from "../resources/svg/accept-btn.svg";

const AcceptBtn = ({ onClick, width = "100%", height = "100%" }) => {
  return (
    <img
      src={acceptSVG}
      className="AcceptBtn"
      width={width}
      height={height}
      alt="AcceptBtn"
      role="button"
      tabIndex="0"
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") onClick();
      }}
    />
  );
};

export default AcceptBtn;
